import React, { useCallback, useState, useEffect } from "react";
import { connect } from "react-redux";

import { adminReduxConstants, EMPTY_STRING } from "../../../constants";
import {
  convertToDateToUnix,
  convertFromDateToUnix,
} from "../../../shared/utility";
import MainSpinner from "../../../shared/components/spinner/MainSpinner";
import MainContentWrapper from "../../../shared/components/main-content-wrapper/MainContentWrapper";
import { adminActions } from "../../../redux/actions/admin.actions";
import DateFilter from "./DateFilter";
import DashboardCards from "./DashboardCards";

const AdminDashboard = ({
  dashboardData,
  spinnerActions,
  fetchDashboardData,
}) => {
  const [endDate, setEndDate] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [errorMessage, setErrorMessage] = useState(EMPTY_STRING);

  const spinner = useCallback(
    (type) => {
      return spinnerActions.findIndex((s) => s === type);
    },
    // eslint-disable-next-line
    [spinnerActions]
  );

  // Fetch data without filters initially
  useEffect(() => {
    fetchDashboardData(startDate, endDate);
  }, []);

  // Fetch dashboard data whenever date filters change
  useEffect(() => {
    if (startDate && endDate && new Date(endDate) < new Date(startDate)) {
      setErrorMessage("End Date must be greater than Start Date");
    } else if (startDate || endDate) {
      fetchDashboardData(
        startDate ? convertFromDateToUnix(startDate) : null,
        endDate ? convertToDateToUnix(endDate) : null
      );
      setErrorMessage(EMPTY_STRING);
    }
  }, [startDate, endDate]);

  const handleResetFilter = () => {
    if (startDate || endDate) {
      setStartDate(null);
      setEndDate(null);
      fetchDashboardData(null, null);
      setErrorMessage(EMPTY_STRING);
    }
  };

  return (
    <MainContentWrapper>
      {spinner(adminReduxConstants.GET_DASHBOARD_DATA) > -1 && (
        <MainSpinner className="admin-spinner" />
      )}
      <div className="admin-page-heading">Dashboard</div>
      <DateFilter
        startDate={startDate}
        endDate={endDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        onReset={handleResetFilter}
        errorMessage={errorMessage}
      />
      <DashboardCards data={dashboardData} />
    </MainContentWrapper>
  );
};

const mapStateToProps = (state) => ({
  dashboardData: state.adminReducer.dashboard,
  spinnerActions: state.systemReducer.spinnerActions,
});

const mapDispatchToProps = (dispatch) => ({
  fetchDashboardData: (startDate, endDate) => {
    dispatch(adminActions.GetDashboardData({ startDate, endDate }));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(AdminDashboard);
